//StaffHolidayCalendar

///staffholidaycalendar/list
export const STAFF_HOLIDAY_CALENDAR_LIST = "STAFF_HOLIDAY_CALENDAR_LIST";
export const STAFF_HOLIDAY_CALENDAR_LIST_SUCCESS =
  "STAFF_HOLIDAY_CALENDAR_LIST_SUCCESS";
export const STAFF_HOLIDAY_CALENDAR_LIST_FAIL =
  "STAFF_HOLIDAY_CALENDAR_LIST_FAIL";

///staffholidaycalendar/data
export const STAFF_HOLIDAY_CALENDAR_DATA = "STAFF_HOLIDAY_CALENDAR_DATA";
export const STAFF_HOLIDAY_CALENDAR_DATA_SUCCESS =
  "STAFF_HOLIDAY_CALENDAR_DATA_SUCCESS";
export const STAFF_HOLIDAY_CALENDAR_DATA_FAIL =
  "STAFF_HOLIDAY_CALENDAR_DATA_FAIL";

///staffholidaycalendar/create
export const STAFF_HOLIDAY_CALENDAR_CREATE = "STAFF_HOLIDAY_CALENDAR_CREATE";
export const STAFF_HOLIDAY_CALENDAR_CREATE_SUCCESS =
  "STAFF_HOLIDAY_CALENDAR_CREATE_SUCCESS";
export const STAFF_HOLIDAY_CALENDAR_CREATE_FAIL =
  "STAFF_HOLIDAY_CALENDAR_CREATE_FAIL";

///staffholidaycalendar/update
export const STAFF_HOLIDAY_CALENDAR_UPDATE = "STAFF_HOLIDAY_CALENDAR_UPDATE";
export const STAFF_HOLIDAY_CALENDAR_UPDATE_SUCCESS =
  "STAFF_HOLIDAY_CALENDAR_UPDATE_SUCCESS";
export const STAFF_HOLIDAY_CALENDAR_UPDATE_FAIL =
  "STAFF_HOLIDAY_CALENDAR_UPDATE_FAIL";

///staffholidaycalendar/delete
export const STAFF_HOLIDAY_CALENDAR_DELETE = "STAFF_HOLIDAY_CALENDAR_DELETE";
export const STAFF_HOLIDAY_CALENDAR_DELETE_SUCCESS =
  "STAFF_HOLIDAY_CALENDAR_DELETE_SUCCESS";
export const STAFF_HOLIDAY_CALENDAR_DELETE_FAIL =
  "STAFF_HOLIDAY_CALENDAR_DELETE_FAIL";

///staffholidaycalendar/generateperiods
export const STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS =
  "STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS";
export const STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS_SUCCESS =
  "STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS_SUCCESS";
export const STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS_FAIL =
  "STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS_FAIL";

//StaffHolidayCalendarPeriod

///staffholidaycalendarperiod/list
export const STAFF_HOLIDAY_CALENDAR_PERIOD_LIST =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_LIST";
export const STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS";
export const STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL";

///staffholidaycalendarperiod/data
export const STAFF_HOLIDAY_CALENDAR_PERIOD_DATA =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_DATA";
export const STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_SUCCESS =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_SUCCESS";
export const STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_FAIL =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_FAIL";

///staffholidaycalendarperiod/create
export const STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE";
export const STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE_SUCCESS =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE_SUCCESS";
export const STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE_FAIL =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE_FAIL";

///staffholidaycalendarperiod/update
export const STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE";
export const STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE_SUCCESS =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE_SUCCESS";
export const STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE_FAIL =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE_FAIL";

///staffholidaycalendarperiod/delete
export const STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE";
export const STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE_SUCCESS =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE_SUCCESS";
export const STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE_FAIL =
  "STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE_FAIL";

//CalendarNonWorkingDay
///calendarnonworkingday/list
export const CALENDAR_NON_WORKING_DAY_LIST = "CALENDAR_NON_WORKING_DAY_LIST";
export const CALENDAR_NON_WORKING_DAY_LIST_SUCCESS =
  "CALENDAR_NON_WORKING_DAY_LIST_SUCCESS";
export const CALENDAR_NON_WORKING_DAY_LIST_FAIL =
  "CALENDAR_NON_WORKING_DAY_LIST_FAIL";

///calendarnonworkingday/data
export const CALENDAR_NON_WORKING_DAY_DATA = "CALENDAR_NON_WORKING_DAY_DATA";
export const CALENDAR_NON_WORKING_DAY_DATA_SUCCESS =
  "CALENDAR_NON_WORKING_DAY_DATA_SUCCESS";
export const CALENDAR_NON_WORKING_DAY_DATA_FAIL =
  "CALENDAR_NON_WORKING_DAY_DATA_FAIL";

///calendarnonworkingday/create
export const CALENDAR_NON_WORKING_DAY_CREATE =
  "CALENDAR_NON_WORKING_DAY_CREATE";
export const CALENDAR_NON_WORKING_DAY_CREATE_SUCCESS =
  "CALENDAR_NON_WORKING_DAY_CREATE_SUCCESS";
export const CALENDAR_NON_WORKING_DAY_CREATE_FAIL =
  "CALENDAR_NON_WORKING_DAY_CREATE_FAIL";

///calendarnonworkingday/update
export const CALENDAR_NON_WORKING_DAY_UPDATE =
  "CALENDAR_NON_WORKING_DAY_UPDATE";
export const CALENDAR_NON_WORKING_DAY_UPDATE_SUCCESS =
  "CALENDAR_NON_WORKING_DAY_UPDATE_SUCCESS";
export const CALENDAR_NON_WORKING_DAY_UPDATE_FAIL =
  "CALENDAR_NON_WORKING_DAY_UPDATE_FAIL";

///calendarnonworkingday/delete
export const CALENDAR_NON_WORKING_DAY_DELETE =
  "CALENDAR_NON_WORKING_DAY_DELETE";
export const CALENDAR_NON_WORKING_DAY_DELETE_SUCCESS =
  "CALENDAR_NON_WORKING_DAY_DELETE_SUCCESS";
export const CALENDAR_NON_WORKING_DAY_DELETE_FAIL =
  "CALENDAR_NON_WORKING_DAY_DELETE_FAIL";

///staffleave/create/request
export const STAFF_LEAVE_CREATE_REQUEST = "STAFF_LEAVE_CREATE_REQUEST";
export const STAFF_LEAVE_CREATE_REQUEST_SUCCESS =
  "STAFF_LEAVE_CREATE_REQUEST_SUCCESS";
export const STAFF_LEAVE_CREATE_REQUEST_FAIL =
  "STAFF_LEAVE_CREATE_REQUEST_FAIL";

///stafftostaffholidaycalendarperiod/list/current
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_SUCCESS =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_SUCCESS";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_FAIL =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_FAIL";

///stafftostaffholidaycalendarperiod/list/future
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_SUCCESS =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_SUCCESS";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_FAIL =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_FAIL";

///stafftostaffholidaycalendarperiod/list/past
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_SUCCESS =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_SUCCESS";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_FAIL =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_FAIL";

///stafftostaffholidaycalendarperiod/list
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL";

///staffleavedecision/approve
export const STAFF_LEAVE_DECISION_APPROVE = "STAFF_LEAVE_DECISION_APPROVE";
export const STAFF_LEAVE_DECISION_APPROVE_SUCCESS =
  "STAFF_LEAVE_DECISION_APPROVE_SUCCESS";
export const STAFF_LEAVE_DECISION_APPROVE_FAIL =
  "STAFF_LEAVE_DECISION_APPROVE_FAIL";

///staffleavedecision/decline
export const STAFF_LEAVE_DECISION_DECLINE = "STAFF_LEAVE_DECISION_DECLINE";
export const STAFF_LEAVE_DECISION_DECLINE_SUCCESS =
  "STAFF_LEAVE_DECISION_DECLINE_SUCCESS";
export const STAFF_LEAVE_DECISION_DECLINE_FAIL =
  "STAFF_LEAVE_DECISION_DECLINE_FAIL";

///stafftostaffholidaycalendarperiod/list/current/myteammembers
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_SUCCESS =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_SUCCESS";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_FAIL =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_FAIL";

///stafftostaffholidaycalendarperiod/list/current/my
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_SUCCESS =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_SUCCESS";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_FAIL =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_FAIL";

///staffleavedecision/data
export const STAFF_LEAVE_DECISION_DATA = "STAFF_LEAVE_DECISION_DATA";
export const STAFF_LEAVE_DECISION_DATA_SUCCESS =
  "STAFF_LEAVE_DECISION_DATA_SUCCESS";
export const STAFF_LEAVE_DECISION_DATA_FAIL = "STAFF_LEAVE_DECISION_DATA_FAIL";

///staffleavedecision/list/my/open
export const STAFF_LEAVE_DECISION_LIST_MY_OPEN =
  "STAFF_LEAVE_DECISION_LIST_MY_OPEN";
export const STAFF_LEAVE_DECISION_LIST_MY_OPEN_SUCCESS =
  "STAFF_LEAVE_DECISION_LIST_MY_OPEN_SUCCESS";
export const STAFF_LEAVE_DECISION_LIST_MY_OPEN_FAIL =
  "STAFF_LEAVE_DECISION_LIST_MY_OPEN_FAIL";

////staffleavedecision/list
export const STAFF_LEAVE_DECISION_LIST = "STAFF_LEAVE_DECISION_LIST";
export const STAFF_LEAVE_DECISION_LIST_SUCCESS =
  "STAFF_LEAVE_DECISION_LIST_SUCCESS";
export const STAFF_LEAVE_DECISION_LIST_FAIL = "STAFF_LEAVE_DECISION_LIST_FAIL";

//Overview
///Overview /stafftostaffholidaycalendarperiod/list/current
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT =
  "OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT";
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_SUCCESS =
  "OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_SUCCESS";
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_FAIL =
  "OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_FAIL";

///Overview /stafftostaffholidaycalendarperiod/list/future
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE =
  "OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE";
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_SUCCESS =
  "OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_SUCCESS";
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_FAIL =
  "OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_FAIL";

///Overview /stafftostaffholidaycalendarperiod/list/past
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST =
  "OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST";
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_SUCCESS =
  "OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_SUCCESS";
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_FAIL =
  "OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_FAIL";

///Overview /stafftostaffholidaycalendarperiod/list
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST =
  "OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST";
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS =
  "OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS";
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL =
  "OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL";

///stafftostaffholidaycalendarperiod/list/open/myandmyteammembers
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_SUCCESS =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_SUCCESS";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_FAIL =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_FAIL";

///stafftostaffholidaycalendarperiod/search
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_SUCCESS =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_SUCCESS";
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_FAIL =
  "STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_FAIL";

//StaffLeaveRestrictionPeriod

///staffleaverestrictionperiod/list
export const STAFF_LEAVE_RESTRICTION_PERIOD_LIST =
  "STAFF_LEAVE_RESTRICTION_PERIOD_LIST";
export const STAFF_LEAVE_RESTRICTION_PERIOD_LIST_SUCCESS =
  "STAFF_LEAVE_RESTRICTION_PERIOD_LIST_SUCCESS";
export const STAFF_LEAVE_RESTRICTION_PERIOD_LIST_FAIL =
  "STAFF_LEAVE_RESTRICTION_PERIOD_LIST_FAIL";

///staffleaverestrictionperiod/data
export const STAFF_LEAVE_RESTRICTION_PERIOD_DATA =
  "STAFF_LEAVE_RESTRICTION_PERIOD_DATA";
export const STAFF_LEAVE_RESTRICTION_PERIOD_DATA_SUCCESS =
  "STAFF_LEAVE_RESTRICTION_PERIOD_DATA_SUCCESS";
export const STAFF_LEAVE_RESTRICTION_PERIOD_DATA_FAIL =
  "STAFF_LEAVE_RESTRICTION_PERIOD_DATA_FAIL";

///staffleaverestrictionperiod/create
export const STAFF_LEAVE_RESTRICTION_PERIOD_CREATE =
  "STAFF_LEAVE_RESTRICTION_PERIOD_CREATE";
export const STAFF_LEAVE_RESTRICTION_PERIOD_CREATE_SUCCESS =
  "STAFF_LEAVE_RESTRICTION_PERIOD_CREATE_SUCCESS";
export const STAFF_LEAVE_RESTRICTION_PERIOD_CREATE_FAIL =
  "STAFF_LEAVE_RESTRICTION_PERIOD_CREATE_FAIL";

///staffleaverestrictionperiod/update
export const STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE =
  "STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE";
export const STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE_SUCCESS =
  "STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE_SUCCESS";
export const STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE_FAIL =
  "STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE_FAIL";

///staffleave/seedapproved
export const SEED_APPROVED_STAFF_LEAVE = "SEED_APPROVED_STAFF_LEAVE";
export const SEED_APPROVED_STAFF_LEAVE_SUCCESS =
  "SEED_APPROVED_STAFF_LEAVE_SUCCESS";
export const SEED_APPROVED_STAFF_LEAVE_FAIL = "SEED_APPROVED_STAFF_LEAVE_FAIL";

///staffleaverestrictionperiod/delete
export const STAFF_LEAVE_RESTRICTION_PERIOD_DELETE =
  "STAFF_LEAVE_RESTRICTION_PERIOD_DELETE";
export const STAFF_LEAVE_RESTRICTION_PERIOD_DELETE_SUCCESS =
  "STAFF_LEAVE_RESTRICTION_PERIOD_DELETE_SUCCESS";
export const STAFF_LEAVE_RESTRICTION_PERIOD_DELETE_FAIL =
  "STAFF_LEAVE_RESTRICTION_PERIOD_DELETE_FAIL";
